'use strict';

/**
 *
 * @name: editorial
 *
 */

import DirectiveTemplate from './nn-editorial.directive.html';
import './nn-editorial.directive.scss';

function EditorialDirective(
  transObject,
  $filter,
  apiPostService,
  $location,
  $translate
) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    scope: {
      content: '&',
      loaded: '='
    },
    transclude: true,
    template: DirectiveTemplate,
    link: function(scope, element, $rootScope) {

      scope.item = scope.content();

      function terminate() {

        scope.$destroy();
        element.find('*').remove();
        element.remove();
      }

      if (!scope.item.jsonData.sources ||
        !scope.item.jsonData.sources[0] ||
        !scope.item.jsonData.sources[1] ||
        (!scope.item.jsonData.sources[0].postId && !scope.item.jsonData.sources[0].order) ||
        (!scope.item.jsonData.sources[0].postId && !scope.item.jsonData.sources[0].order[0]) ||
        (!scope.item.jsonData.sources[1].postId && !scope.item.jsonData.sources[1].order) ||
        (!scope.item.jsonData.sources[1].postId && !scope.item.jsonData.sources[1].order[0])) {
        return terminate();
      }

      var hashTable = {
        'publishDate desc': 'MOST_RECENT',
        'publishDate asc': 'LEAST_RECENT',
        'lovesCount desc': 'HIGHEST_RATED',
        'lovesCount asc': 'LEAST_RATED',
        'viewsCount desc': 'MOST_POPULAR',
        'viewsCount asc': 'LEAST_POPULAR',
        'commentsCount desc': 'MOST_COMMENTED',
        'commentsCount asc': 'LEAST_COMMENTED',
        'recommended desc': 'MOST_RECOMMENDED',
        'recommended asc': 'LEAST_RECOMMENDED'

      };

      scope.item.jsonData.sources.forEach(function(item, index) {

        if (item.hasOwnProperty('postId')) {

          if (index > 0) {

            if (scope.item.posts[index] && scope.item.posts[index].id === item.postId) {

              runThePosts();
            } else {

              var postLengthWatch = scope.$watch('item.posts.length', function(newVal) {

                if (newVal === 2) {

                  runThePosts();
                  postLengthWatch();
                }
              });
            }
          }
        } else {

          var callOrder = null;
          var categoryId = null;

          if (item.hasOwnProperty('order')) {

            callOrder = item.order[0];
          }

          if (item.hasOwnProperty('categoryId')) {

            categoryId = item.categoryId;
          }

          apiPostService
            .getPost(categoryId, callOrder, 1, 1)
            .then(function(result) {

              var resPost = result.data.items[0];

              if (index === 0) {

                scope.item.posts.unshift(resPost);
              } else {

                scope.item.posts.push(resPost);

                if (scope.item.posts.length === 2) {

                  runThePosts();
                } else {

                  var postLengthWatch = scope.$watch('item.posts.length', function(newVal) {

                    if (newVal === 2) {

                      runThePosts();
                      postLengthWatch();
                    }
                  });
                }
              }

            });

          transObject.isPublished(item);
        }
      });

      scope.onAnalyticsClick = (post, id) => {
        window._hmt.push(['_trackEvent', '组件', 'click', `parentType=${scope.item.parentType},index=${scope.item.index},moduleId=${scope.item.id},parentSlug=${scope.item.parentSlug || ''}`]);
        $rootScope.analytics.videoAM('editorial', scope.item.jsonData.sources[id].title, post)
      }

      function runThePosts() {

        var swap = false;

        scope.item.posts.forEach(function(item, itemIndex) {

          scope.item.jsonData.sources.forEach(function(source, sourceIndex) {

            if (source.postId === item.id) {

              if (itemIndex !== sourceIndex) {

                swap = true;
              }
            }
          });

          transObject.translate(item);
          transObject.getDuration(item);
          transObject.setBookmark(item);
          transObject.trueSlug(item);
          transObject.isPublished(item);
        });

        if (swap) {

          var swapper = scope.item.posts.splice(1, 1)[0];
          scope.item.posts.unshift(swapper);
        }

        scope.item.jsonData.sources.forEach(function(source, sourceIndex) {

          var title;

          if (!source.title && !scope.item.posts[sourceIndex].published) {

            title = 'COMING_SOON';
          }
          if (!source.title && scope.item.posts[sourceIndex].published) {

            title = 'SELECTED';
          }

          if (source.title) {

            title = source.title;
          }

          if (!source.title && source.hasOwnProperty('order')) {

            title = $translate.instant(hashTable[source.order[0]]);

            if (source.hasOwnProperty('categoryId')) {

              var categoryId = scope.item.posts[sourceIndex].CategoryId;
              title = title + ' ' + $translate.instant('IN') + ' ' + $rootScope.categoryList[categoryId].translations[$rootScope.lang].name;
            }
          }

          source.title = $translate.instant(title);
        });

        setTimeout(function() {

          scope.$apply();
        });

        scope.loaded = true;
      }
    }
  };
}

export default EditorialDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-editorial/nn-editorial.directive.js